import { debounce } from 'es-toolkit/compat'

export default debounce
